/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { DeleteOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Collapse,
  Divider,
  Input,
  InputNumber,
  message,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Steps,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import Emoji from "react-emoji-render";
import { v4 as uuidv4 } from "uuid";

import { getSupaClient, getWorkspace } from "../../lib/supabase";
import { TAG_COLORS } from "../../utils/constants";
import { SlackEditor } from "../TextEditor/SlackEditor";
import useSavedSurveys from "./useSavedSurveys";

const { Option } = Select;

const { Step } = Steps;
const moment = require("moment-timezone");

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
const timezones = moment.tz.names();

/**
 * Component for survey creation.
 * @param {function} closeModal A function to handle the modal windows onClose event.
 * @param {function} loadTriggers A function that handle the triggers loading.
 * @param {array} selectedUsers A collection of members ID.
 * @param {function} trigger A function that describes the current trigger.
 * @param {string} type A value that represent the type of form that should be displayed.
 * @param {array} userSettings A object containing all user preferences.
 * @param {boolean} wasTriggered A boolean value that represents if the form was invoked from a trigger creation process.
 */
const BotMessages = (props) => {
  const supabase = getSupaClient();
  const workspace = getWorkspace(supabase);
  const teamId = localStorage.getItem("team-id");
  const slackId = localStorage.getItem("slack-id");
  const [triggerType, setTriggerType] = useState("team_join");
  const [newTag, setNewTag] = useState();
  const [errors, setErrors] = useState(null);
  const [nameValue, setNameValue] = useState("");
  const [selectedTeammate, setSelectedTeammate] = useState("");
  const [teammates, setTeammates] = useState([]);
  const [sendNow, setSendNow] = useState(true);
  const [saveAsTemplate, setSaveAsTemplate] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState("");
  const [dateTimeObj, setDateTimeObj] = useState(new Date());
  const [selectSavedToDelete, setSelectSavedToDelete] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [delayType, setDelayType] = useState("now");
  const [customTime, setCustomTime] = useState(null);

  const {
    loading,
    savedSurveyList,
    setSavedSurveyList,
    selectedSavedSurveyId,
    setSelectedSavedSurveyId,
    surveyName,
    setSurveyName,
    welcomeMessage,
    setWelcomeMessage,
    questionsData,
    setQuestionsData,
    teamTags,
    setTeamTags,
  } = useSavedSurveys(props.trigger);

  const addOption = (questionId) => {
    const updatedOptions = questionsData.map((item) => {
      if (questionId === item.question_id) {
        item = {
          ...item,
          options: [
            ...item.options,
            {
              text: "",
              id: item.options.length + 1,
              tags: [],
              memberTags: [],
              memberTagsId: [],
            },
          ],
        };
      }
      return item;
    });
    setQuestionsData(updatedOptions);
  };

  const handleSetEditTags = () => {
    if (props.type === "edit") {
      let updatedOptions = null;
      teamTags.map((item) => {
        updatedOptions = questionsData.map((question) => {
          question.options.map((option) => {
            option.memberTagsId.map((member) => {
              if (item.id === member) {
                option.memberTags.push(item);
                option.tags.push(item);
              }
              return member;
            });
            return option;
          });
          return question;
        });
        return item;
      });
      if (updatedOptions !== null) {
        setQuestionsData(updatedOptions);
      }
    }
  };

  useEffect(() => {
    handleSetEditTags();
  }, [teamTags]);

  useMemo(() => {
    if (props.type === "edit") {
      const configOptions = props.trigger.config[0].onboarding_questions;
      setSelectedTeammate(props.trigger.config[0].sendAs);
      setNameValue(props.trigger.name);
      const data = configOptions
        .filter((q) => q.question_type !== "message")
        .map((question, index) => {
          let item = {
            questionValue: question.question,
            question_id: index + 1,
          };

          const options = question.answers.map((option, count) => {
            const tempOption = {
              text: option.display,
              id: count + 1,
              tags: [],
              memberTagsId: option.maps_to_tags,
              memberTags: [],
            };

            return tempOption;
          });

          item = {
            ...item,
            options,
          };

          return item;
        });
      setQuestionsData(data);
    }
    handleSetEditTags();
  }, [props.trigger]);

  const getScheduledTime = () => {
    let scheduledTime = null;
    if (!sendNow) {
      const timeStr = moment(dateTimeObj).format("YYYY-MM-DD HH:mm A");
      scheduledTime = moment.tz(
        timeStr,
        "YYYY-MM-DD HH:mm A",
        selectedTimezone
      );
    } else {
      const now = moment().add(2, "m").set("second", 0).set("millisecond", 0);
      scheduledTime = moment.tz(now, selectedTimezone);
    }
    return scheduledTime;
  };

  const saveQuestionData = async () => {
    const configOptions = questionsData.map((question) => {
      let formattedQuestion;
      if (question.message) {
        formattedQuestion = {
          question_type: question.question_type,
          message: question.message,
          id: uuidv4(),
        };
      } else {
        const options = question.options.map((item) => {
          const obj = {
            display: item.text,
            maps_to_tags: item.memberTagsId,
            id: uuidv4(),
          };
          return obj;
        });
        formattedQuestion = {
          question_type: question.question_type,
          question: question.questionValue,
          id: uuidv4(),
          answers: options,
        };
      }
      return formattedQuestion;
    });

    // add a welcome message if provided
    const extractedWelcomeMessage =
      welcomeMessage.slack_mrkdwn || welcomeMessage.text;
    if (extractedWelcomeMessage)
      configOptions.splice(0, 0, {
        question_type: "message",
        message: extractedWelcomeMessage,
        id: uuidv4(),
      });

    let count = 0;
    let shouldInsert = true;
    questionsData.map((question) => {
      if (question.questionValue === "") {
        shouldInsert = false;
      }
      question.options.map((item) => {
        if (item.text !== "" && item.tags.length !== 0) {
          count += 1;
        } else {
          shouldInsert = false;
        }
        return count;
      });
      if (count < 2) {
        shouldInsert = false;
      }
      count = 0;
      return shouldInsert;
    });
    let finalSurveyName = "";
    if (nameValue) {
      finalSurveyName = nameValue.includes("- through Trigger")
        ? nameValue
        : `${nameValue} - through Trigger`;
    } else {
      finalSurveyName = surveyName;
    }
    if (shouldInsert && finalSurveyName !== "") {
      const savedSurvey = await supabase.from("saved_surveys").insert([
        {
          name: finalSurveyName,
          survey_content: {
            onboarding_questions: configOptions,
          },
          team: teamId,
          workspace,
          is_template: saveAsTemplate,
        },
      ]);
      const surveyData = savedSurvey.data[0];
      if (savedSurvey.error) {
        message.error("Error saving. Please try again", savedSurvey.error);
      }
      // if data exist, update the list locally. And if template, show a success message
      if (savedSurvey.data) {
        if (savedSurvey.data[0].is_template) {
          window.analytics.track("Survey saved as template");
          message.success("Template saved successfully");
        }
        savedSurveyList.push(surveyData);
      }

      window.analytics.track("Survey scheduled");

      if (props.trigger) {
        const triggerConfig = [
          {
            sendAs: selectedTeammate,
            time: "now",
            survey_id: surveyData.id,
          },
        ];
        const updatedTrigger = await supabase
          .from("team_triggers")
          .update({
            team: teamId,
            created_by: slackId,
            name: nameValue,
            type: triggerType,
            config: triggerConfig,
          })
          .match({ id: props.trigger.id });
        if (updatedTrigger.error) {
          message.error("Error saving. Please try again");
        }
        if (updatedTrigger.data) {
          message.success("Saved!");
          if (props.closeModal) props.closeModal();
          await props.loadTriggers();
        }
      } else {
        let newTrigger = null;
        if (props.type === "sendSurvey") {
          const scheduledTimeLocal = getScheduledTime().format();
          const scheduledTimeUTC = getScheduledTime().utc().format();
          newTrigger = await supabase.from("scheduled_tasks").insert([
            {
              scheduled_time_utc: scheduledTimeUTC,
              scheduled_time_local: scheduledTimeLocal,
              timezone: selectedTimezone,
              team: teamId,
              created_by: slackId,
              run_function: "sendSurveyQuestions",
              sender: selectedTeammate === "bot" ? null : selectedTeammate,
              payload: {
                recipient: props.selectedUsers || [],
                sender: selectedTeammate,
                survey_id: surveyData.id,
                team: teamId,
              },
              workspace,
            },
          ]);
        } else {
          const triggerConfig = [
            {
              sendAs: selectedTeammate,
              time: delayType,
              custom_time: customTime,
              survey_id: surveyData.id,
            },
          ];
          newTrigger = await supabase.from("team_triggers").insert([
            {
              team: teamId,
              created_by: slackId,
              name: nameValue,
              type: triggerType,
              config: triggerConfig,
              workspace,
            },
          ]);
        }

        if (newTrigger.error) {
          console.log(newTrigger);
          message.error("Error saving. Please try again");
        }
        if (newTrigger.data) {
          message.success("Scheduled survey!");
          if (props.closeModal) props.closeModal();
          if (props.loadTriggers) await props.loadTriggers();
        }
      }
    } else {
      message.error("Error saving. Please try again with all fields filled");
    }
  };

  const loadTeammates = async () => {
    const { data, error } = await supabase
      .from("users")
      .select("name, slack_id")
      .filter("team", "eq", teamId);

    if (error) {
      console.log("Error loading teammates", error);
      window.analytics.track("Teammates load error");
    }
    if (data && data[0]) {
      data.push({ name: "bot", slack_id: "bot" });
      setTeammates(data);
    }
  };
  /**
   * Load Saved Survey from saved_surveys
   */
  const loadSavedSurvey = async () => {
    const { data, error } = await supabase
      .from("saved_surveys")
      .select("id, name, survey_content, is_template")
      .filter("team", "eq", teamId);

    if (error) {
      console.log("Error loading saved survey", error);
      window.analytics.track("Saved Survey load error");
    }
    if (data && data[0]) {
      setSavedSurveyList(data);
    }
  };

  useEffect(() => {
    loadTeammates();
    setSelectedTimezone(moment.tz.guess());
  }, []);

  function tagRender(questionId, id, payload) {
    const { onClose, closable, value } = payload;
    let memberTag = {};
    if (payload.value) {
      questionsData.map((question) => {
        if (questionId === question.question_id)
          question.options.map((item) => {
            if (item.id === id) {
              memberTag = item.memberTags.find(
                (element) => element?.id === payload.value
              );
            }
            return memberTag;
          });
        return question;
      });

      if (memberTag) {
        return (
          <Tag
            color={memberTag.color}
            closable={closable}
            onClose={onClose}
            style={{ marginRight: 3 }}
            key={value}
          >
            {memberTag.name}
          </Tag>
        );
      }
      return null;
    }
    return null;
  }

  function returnTagObj(value) {
    return teamTags.find((item) => item.id === value);
  }

  const onSelect = async (questionId, optionId, selection) => {
    const selectedTag = returnTagObj(selection);

    const updatedOptions = questionsData.map((item) => {
      let tempOptions = [];
      if (item.question_id === questionId) {
        tempOptions = item.options.map((option) => {
          if (option.id === optionId) {
            option.tags.push(selectedTag);
            option.memberTags.push(selectedTag);
            option.memberTagsId.push(selection);
          }
          return option;
        });
        item = {
          ...item,
          options: tempOptions,
        };
      }
      return item;
    });
    setQuestionsData(updatedOptions);
  };

  const onDeselect = async (questionId, id, selection) => {
    const updatedOptions = questionsData.map((question) => {
      let tempOptions = [];
      if (questionId === question.question_id) {
        tempOptions = question.options.map((item) => {
          if (item.id === id) {
            const filteredTags = item.tags.filter(
              (tag) => tag.id !== selection
            );
            const filteredMemberTags = item.memberTags.filter(
              (tag) => tag.id !== selection
            );
            const filteredMemberTagsId = item.memberTagsId.filter(
              (tag) => tag !== selection
            );
            item = {
              ...item,
              tags: filteredTags,
              memberTags: filteredMemberTags,
              memberTagsId: filteredMemberTagsId,
            };
          }
          return item;
        });
        question = {
          ...question,
          options: tempOptions,
        };
      }

      return question;
    });

    setQuestionsData(updatedOptions);
  };

  const getNewTagColor = () => {
    let tagColor = "";
    if (teamTags.length < TAG_COLORS.length) {
      tagColor = TAG_COLORS[teamTags.length];
    } else {
      tagColor = TAG_COLORS[teamTags.length % TAG_COLORS.length];
    }
    return tagColor;
  };

  const onTagNameChange = (event) => {
    event.preventDefault();
    setNewTag(event.target.value);
  };

  const addItem = async (questionId, id) => {
    const tagColor = getNewTagColor();
    const { data, error } = await supabase
      .from("tags")
      .insert([{ name: newTag, team: teamId, color: tagColor, workspace }]);
    if (data) {
      window.analytics.track("New team tag added");
      setTeamTags(
        teamTags.concat({
          id: data[0].id,
          name: data[0].name,
          color: data[0].color,
        })
      );
      const updatedOptions = questionsData.map((question) => {
        let tempOptions = [];
        if (questionId === question.question_id) {
          tempOptions = question.options.map((item) => {
            if (item.id === id) {
              item.tags.push(data[0]);
              item.memberTags.push(data[0]);
              item.memberTagsId.push(data[0].id);
            }
            return item;
          });
          question = {
            ...question,
            options: tempOptions,
          };
        }
        return question;
      });
      setQuestionsData(updatedOptions);
      setNewTag("");
      setErrors();
    }
    if (error) {
      setErrors({ teamTag: true });
    }
  };

  const handleChangeInputOption = (questionId, optionId, value) => {
    const updatedOptions = questionsData.map((item) => {
      let tempOptions = [];
      if (item.question_id === questionId) {
        tempOptions = item.options.map((option) => {
          if (option.id === optionId) {
            option = { ...option, text: value };
          }
          return option;
        });
        item = {
          ...item,
          options: tempOptions,
        };
      }
      return item;
    });
    setQuestionsData(updatedOptions);
  };

  const handleChangeInputQuestionValue = (questionId, value) => {
    const updatedOptions = questionsData.map((item) => {
      if (item.question_id === questionId) {
        item = {
          ...item,
          questionValue: value,
        };
      }
      return item;
    });
    setQuestionsData(updatedOptions);
  };

  const handleChangeInputQuestionTypeValue = (questionId, type) => {
    const updatedOptions = questionsData.map((item) => {
      if (item.question_id === questionId) {
        item = {
          ...item,
          question_type: type,
        };
      }
      return item;
    });
    setQuestionsData(updatedOptions);
  };
  const addNewQuestion = () => {
    setQuestionsData([
      ...questionsData,
      {
        question_type: "one",
        questionValue: "",
        question_id: questionsData.length + 1,
        options: [
          { text: "", id: 1, tags: [], memberTags: [], memberTagsId: [] },
          { text: "", id: 2, tags: [], memberTags: [], memberTagsId: [] },
        ],
      },
    ]);
  };

  const deleteQuestion = (questionId) => {
    const updatedOptions = questionsData.filter(
      (item) => questionId !== item.question_id
    );
    setQuestionsData(updatedOptions);
  };

  const deleteOption = (questionId, optionId) => {
    const updatedOptions = questionsData.map((item) => {
      let tempOptions = [];
      if (item.question_id === questionId) {
        tempOptions = item.options.filter((option) => option.id !== optionId);
        item = {
          ...item,
          options: tempOptions,
        };
      }
      return item;
    });
    setQuestionsData(updatedOptions);
  };

  /**
   *  Show delete modal
   * @param {Object} survey that needs to be deleted
   */
  const deleteSurvey = (survey) => {
    setShowDeleteModal(true);
    setSelectSavedToDelete(survey);
  };

  /**
   * Deleting saved survey from database
   */
  const onDeleteClicked = async () => {
    const { data, error } = await supabase
      .from("saved_surveys")
      .delete()
      .match({ id: selectSavedToDelete.id });
    if (error) {
      message.error("Error deleting");
    }
    if (data) {
      message.success("Successfully deleted");
      loadSavedSurvey();
      setShowDeleteModal(false);
      setSelectedSavedSurveyId(null);
    }
  };

  /**
   * Update delayType and customTime state vars when user changes delay type. If changed to now, set
   * customTime to null; if changed to custom, set customTime to 1.
   * @param {*} value
   */
  const onDelayTypeChanged = async (value) => {
    setDelayType(value);
    if (value === "now") setCustomTime(null);
    if (value === "custom") setCustomTime(1);
  };

  return (
    <Space
      key={props.trigger ? props.trigger.id : "bot"}
      direction="vertical"
      style={{ width: "100%", textAlign: "left", padding: "0 20px" }}
    >
      <Space
        direction="vertical"
        style={{ textAlign: "left", marginBottom: 10 }}
      >
        {props.type !== "sendSurvey" ? (
          <Space>
            <span>Name</span>
            <Input
              placeholder="Enter a name"
              value={nameValue}
              type="text"
              onChange={(e) => setNameValue(e.target.value)}
            />
          </Space>
        ) : (
          ""
        )}
        {props.type !== "sendSurvey" ? (
          <Space>
            <span>Select a trigger</span>
            <Select
              onChange={(value) => setTriggerType(value)}
              defaultValue={triggerType}
              style={{ width: 350, marginLeft: 10 }}
            >
              <Option value="team_join">When a new member joins</Option>
            </Select>
          </Space>
        ) : (
          ""
        )}
        <div className="flex justify-between">
          {props.type === "new" ? (
            <Space>
              <span>Select time to send</span>
              <Select
                onChange={(value) => onDelayTypeChanged(value)}
                defaultValue={delayType}
                style={{ width: 350, marginLeft: 10 }}
              >
                <Option value="now">Upon signup</Option>
                <Option value="custom">After X days</Option>
              </Select>
            </Space>
          ) : null}
          {delayType === "custom" ? (
            <Space>
              <div className="ml-4">
                After{" "}
                <InputNumber
                  min={1}
                  max={30}
                  defaultValue={1}
                  value={customTime}
                  onChange={(value) => setCustomTime(value)}
                />{" "}
                days
              </div>
            </Space>
          ) : null}
        </div>
        <Space>
          <span>Send As: </span>
          <Select
            style={{ width: 200, marginLeft: 10 }}
            placeholder="Select user to send as"
            onSelect={setSelectedTeammate}
            value={selectedTeammate || null}
          >
            {teammates.map(function (teammate) {
              return (
                <Option
                  key={teammate.slack_id}
                  value={teammate.slack_id}
                  name={teammate.name}
                >
                  {teammate.name}
                </Option>
              );
            })}
          </Select>
        </Space>
        <Space>
          <span>Start with a templated survey (Optional): </span>
          <Select
            style={{ width: 300, marginLeft: 10 }}
            placeholder="Pick a template"
            onSelect={setSelectedSavedSurveyId}
            value={selectedSavedSurveyId}
          >
            {savedSurveyList.map(function (survey) {
              if (survey.is_template) {
                return (
                  <Option key={survey.id} value={survey.id} name={survey.name}>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <span className="truncate">{survey.name}</span>
                      {survey.id !== selectedSavedSurveyId ? (
                        <Tooltip title="Click here to Delete">
                          <DeleteOutlined
                            onClick={() => deleteSurvey(survey)}
                          />
                        </Tooltip>
                      ) : null}
                    </div>
                  </Option>
                );
              }
              return null;
            })}
          </Select>
        </Space>
        <Space>
          {!props.wasTriggered && (
            <div>
              <span>Survey Name:</span>
              <Input
                placeholder="Survey Name"
                style={{
                  borderRadius: 5,
                  width: "200px",
                  marginLeft: 10,
                }}
                value={surveyName}
                onChange={(e) => setSurveyName(e.target.value)}
              />
            </div>
          )}
        </Space>
      </Space>

      <Space
        direction="vertical"
        style={{ width: "100%", textAlign: "left", marginBottom: 10 }}
      >
        <Collapse>
          <Collapse.Panel
            header="Click here to add an optional welcome message"
            key="1"
          >
            <SlackEditor
              height="125px"
              hidePreview
              initialText=""
              onChange={setWelcomeMessage}
              value={welcomeMessage}
            />
            <span>
              Tip: You can use {"{{first_name}}"} and {"{{@_mention}}"} for
              personalization!
              <Popover
                content={
                  <div style={{ width: 300 }}>
                    <p>
                      We support Markdown formatting.{" "}
                      <a
                        target="_blank"
                        href="https://www.markdownguide.org/basic-syntax/"
                        rel="noreferrer"
                      >
                        (What is markdown?)
                      </a>
                    </p>
                    <p>
                      E.g. To create a link, enclose the link text in brackets
                      (e.g., [Duck Duck Go]) and then follow it immediately with
                      the URL in parentheses (e.g., (https://duckduckgo.com)).
                      You can use the options in the text box to help you do
                      this automatically, and you will see a preview.
                    </p>
                    <p>
                      For emojis, use slack emoji formatting. E.g. type :tada:
                      for <Emoji text=":tada:" />
                    </p>
                  </div>
                }
              >
                <span style={{ color: "#4ca3ee" }}> (More formatting?) </span>
              </Popover>
            </span>
          </Collapse.Panel>
        </Collapse>
      </Space>

      {questionsData.map((question, count) => {
        return (
          <div style={{ marginBottom: 40 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>Question:{count + 1}</span>
              <Input
                placeholder="Enter the question"
                value={question.questionValue}
                type="text"
                style={{ width: "95%", marginLeft: 10 }}
                onChange={(e) =>
                  handleChangeInputQuestionValue(
                    question.question_id,
                    e.target.value
                  )
                }
              />
              <Space>
                <span style={{ paddingLeft: 20 }}> Choice: </span>
                <Select
                  onChange={(value) =>
                    handleChangeInputQuestionTypeValue(
                      question.question_id,
                      value
                    )
                  }
                  value={question.question_type}
                  style={{ width: 200, marginLeft: 10 }}
                >
                  <Option value="one">Single</Option>
                  <Option value="multiples">Multiple</Option>
                </Select>
              </Space>
              {question.question_id > 1 ? (
                <Button
                  onClick={() => deleteQuestion(question.question_id)}
                  size="medium"
                  block
                  style={{ width: "20%", marginLeft: 10 }}
                  icon={<DeleteOutlined />}
                >
                  Delete
                </Button>
              ) : (
                ""
              )}
            </div>
            <div className="mt-3">
              <strong>Note: </strong>
              <span>
                Add your options, and pick what tags to map that option to in
                order to automatically assign tag to that member.
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                width: "60%",
                marginTop: 30,
                marginLeft: 30,
              }}
            >
              <strong style={{ width: "60%" }}>Option</strong>
              <strong style={{ width: "40%" }}>
                What tags to add if this option is selected?
              </strong>
            </div>
            {question.options.map((item, index) => (
              <div
                key={item.id}
                style={{ display: "flex", marginTop: 30, marginLeft: 30 }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "60%",
                  }}
                >
                  <span>{index + 1}.</span>
                  <Input
                    key={item.id}
                    placeholder="Enter the Option"
                    type="text"
                    style={{
                      width: "100%",
                      marginLeft: 10,
                      marginRight: 10,
                    }}
                    value={item.text}
                    onChange={(e) =>
                      handleChangeInputOption(
                        question.question_id,
                        item.id,
                        e.target.value
                      )
                    }
                  />
                  <div style={{ width: "80%" }}>
                    <Select
                      placeholder="Enter the tag to map (required)"
                      mode="multiple"
                      showArrow
                      tagRender={(payload) =>
                        tagRender(question.question_id, item.id, payload)
                      }
                      value={item.memberTagsId}
                      style={{ borderRadius: 10, width: "100%" }}
                      onSelect={(e) =>
                        onSelect(question.question_id, item.id, e)
                      }
                      onDeselect={(e) =>
                        onDeselect(question.question_id, item.id, e)
                      }
                      optionFilterProp="name"
                      dropdownRender={(menu) => (
                        <div>
                          {menu}
                          <Divider style={{ margin: "4px 0" }} />
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "nowrap",
                              padding: 8,
                            }}
                          >
                            <Input
                              style={{ flex: "auto", borderRadius: 5 }}
                              value={newTag}
                              onChange={onTagNameChange}
                              onKeyDown={(e) => e.stopPropagation()}
                            />
                            <Button
                              type="link"
                              style={{
                                flex: "none",
                                padding: "8px",
                                display: "block",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                addItem(question.question_id, item.id)
                              }
                            >
                              <PlusOutlined />
                              New tag
                            </Button>
                          </div>
                          {errors && errors.teamTag ? (
                            <p>Error adding tag, try again please</p>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    >
                      {teamTags.map((tag) => {
                        return (
                          <Option key={tag.id} value={tag.id} name={tag.name}>
                            <Tag
                              style={{
                                border: `0.5px solid ${tag.color}`,
                                borderRadius: 5,
                                borderWidth: "thin",
                                width: "fit-content",
                              }}
                            >
                              {tag.name}
                            </Tag>
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                </div>
                {item.id > 2 ? (
                  <Button
                    onClick={() => deleteOption(question.question_id, item.id)}
                    style={{ marginLeft: 10 }}
                    icon={<DeleteOutlined />}
                  />
                ) : (
                  ""
                )}
              </div>
            ))}

            <div
              style={{
                margin: "auto",
                textAlign: "left",
                marginLeft: 30,
                marginTop: 30,
              }}
            >
              <Button
                type="dashed primary"
                style={{ borderColor: "#1890ff" }}
                onClick={() => addOption(question.question_id)}
              >
                + Add a new option
              </Button>
            </div>
            <Divider />
          </div>
        );
      })}
      <div className="flex flex-row justify-around mb-4">
        <div className="flex flex-row justify-between">
          <div className="mr-8 font-semibold">
            Do you want to save this as a new template:
          </div>
          <div>
            <Space>
              <Radio.Group
                onChange={(val) => setSaveAsTemplate(val.target.value)}
                value={saveAsTemplate}
              >
                <Radio value>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Space>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-around">
        {props.type === "sendSurvey" ? (
          <div className="flex flex-row justify-between">
            <div className="mr-8 font-semibold">Choose when to send:</div>
            <div>
              <Space>
                <Radio.Group
                  onChange={(val) => setSendNow(val.target.value)}
                  value={sendNow}
                >
                  <Radio value>Send now</Radio>
                  <Radio value={false}>Send later</Radio>
                </Radio.Group>
              </Space>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="flex flex-row justify-center">
        {sendNow ? null : (
          <>
            <DateTimePicker
              style={{ marginBottom: 5, width: "auto" }}
              onChange={setDateTimeObj}
              value={dateTimeObj}
              disableClock
            />
            <Select
              placeholder="Timezone"
              onChange={setSelectedTimezone}
              showSearch
              style={{ width: 200, marginLeft: 10 }}
              value={selectedTimezone}
            >
              {timezones.map(function (val) {
                return <Option value={val}>{val}</Option>;
              })}
            </Select>
          </>
        )}
      </div>
      <div
        style={{
          marginTop: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        <Button
          onClick={addNewQuestion}
          type="dashed primary"
          style={{ borderColor: "#1890ff", width: "30%" }}
          size="large"
          block
        >
          + Add a new question
        </Button>
        {props.type !== "sendSurvey" ? (
          <Button
            onClick={saveQuestionData}
            style={{ width: "30%" }}
            size="large"
            type="primary"
            block
            icon={<SaveOutlined />}
          >
            Save
          </Button>
        ) : (
          <Button
            onClick={saveQuestionData}
            style={{ width: "30%" }}
            size="large"
            type="primary"
            block
            icon={<SaveOutlined />}
          >
            {sendNow ? "Send now" : "Schedule"}
          </Button>
        )}
      </div>
      <Modal
        title="Remove as a template"
        visible={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        footer={[
          <Button type="primary" onClick={() => onDeleteClicked()}>
            <DeleteOutlined />
            {" Yes"}
          </Button>,
        ]}
      >
        <p>Do you want to remove {selectSavedToDelete?.name} as a template?</p>
      </Modal>
    </Space>
  );
};

export default BotMessages;
